import { useStateManager } from "@bcm-dev/bcms-vite";
import { Account, Transaction } from "model";
import React from "react";

import CustomTransactionAccordion from "components/custom-ui/CustomTransactionAccordion";
import { TableColumnContainer, TableHeaderView, TableView } from "components/shared";
import { TableBody } from "components/shared/views/TableView";
import { UIButton } from "components/ui";
import { SVGAsset } from "res";
import NoTransactionsView from "../NoTransactionsView";

import "./styles.css";


export default function TransactionsView(props) {
    const { data, ui, onHasMoreClick } = useStateManager();

    const account = data.account;
    const accountID = account.id;

    const filtered = data.transactions;
    const nonFiltered = Transaction.initByAccount(accountID);

    const filterTransactions = (transactions, status) => transactions.filter(transaction => {
        return transaction.account ? transaction.status === status : false;
    }, []);

    // Filter transactions by status
    const pendingTransactions = filterTransactions(filtered, "pending");
    let postedTransactions = filterTransactions(filtered, "posted");
    const allTransactions = [ ...pendingTransactions, ...postedTransactions ];

    // Get the balance from the account
    let balance = account.availableBalance ? account.availableBalance.amount : account.currentBalance.amount;
    // Go through the non filtered transactions and filter them by status and set the balance
    const nonFilteredPending = filterTransactions(nonFiltered, "posted").map(transaction => {

        if(Account.isLOC(account)) {
            let amount = transaction.principal.value + transaction.interest.value;
            transaction.balance = balance;
            transaction.amount = amount;
            balance = balance - amount;
        } else {
            balance = account.type === "loan" ? (balance + transaction.amount.amount) : (balance - transaction.amount.amount);
            transaction.balance = balance;
        }

        return transaction;
    }, []);
    
    // Apply the balance to the filtered transactions
    // Doing this keeps the correct balance even when transactions are filtered
    postedTransactions = postedTransactions.map(transaction => {
        const related = nonFilteredPending.find(item => item.id === transaction.id);
        transaction.amount = related.amount;
        transaction.balance.amount = related !== undefined && related.balance.amount !== undefined ? related.balance.amount : 0;

        return transaction;
    }, []);

    let hasMore = postedTransactions.length > 0;
    postedTransactions = hasMore && ui.showMoreTransactions === false ? postedTransactions.slice(0, 25 - pendingTransactions.length) : postedTransactions;

    // Check if all transactions are shown.
    if((allTransactions.length) === (postedTransactions.length + pendingTransactions.length)) {
        hasMore = false;
    }

    return (
        <div className="transactions-view show-on-desktop">
          {/* Content for transactions. */}
          { allTransactions.length > 0 && 
          <>
            <TableView>
                    <TableColumnContainer>
                        <th></th>
                        <th className="text-left date">Date</th>
                        <th className={ `text-left description ${ (account.type === "loan" || account.type === "loc") ? "loan" : "" }` }>Description</th>
                        { account.type !== "loc" && <th className="text-left type">Type</th> }
                        <th className="text-right amount">Amount</th>
                        { (account.type !== "loan" && account.type !== "loc") && <th className="text-right balance">Balance</th> }
                        { account.type === "loan" && 
                        <>
                        <th className="text-right principal">Principal</th>
                        <th className="text-right interest">Interest</th>
                        <th className="text-right escrow">Escrow</th>
                        </>
                        }
                        { account.type === "loc" && 
                        <>
                        <th className="text-right principal">Principal</th>
                        <th className="text-right interest">Interest</th>
                        <th className="text-right balance">Balance</th>
                        </>
                        }
                    </TableColumnContainer>
                    <TableBody>
                        <TableHeaderView className="deposit-status" text="Pending"
                        colSpan={ (account.type === "loan" || account.type === "loc") ? "8" : "6" } dataPoint="Pending"/>    
                    </TableBody>
                    
                    <TransactionViewTransactions transactions={ pendingTransactions }/>
            
                    <TableBody>
                        <TableHeaderView className="deposit-status" text="Posted" 
                        colSpan={ (account.type === "loan" || account.type === "loc") ? "8" : "6" } dataPoint="Posted"/>
                    </TableBody>
            
                    <TransactionViewTransactions transactions={ postedTransactions } account={ account } />
                </TableView>

                {!hasMore && <EndOfTransactionsWidget />} 
                { hasMore && <div className="text-center">
                <UIButton text="Show More Transactions" className="secondary-button show-more" onClick={ onHasMoreClick } />
                </div>}
            </>
            }
            {/* Content for no transactions */}
            { allTransactions.length === 0 && <NoTransactionsView/> }
        </div>
      );
}

 /**
 * @function EndOfTransactionsWidget
 * @return {React.Component}
 * @exported false
 * @description This shows after "Show More Transactions" is clicked and update the “TranscactionsView” with additional transactions.
 * @example 
 * <EndOfTransactionsWidget />
 */
function EndOfTransactionsWidget(props) {
    return (
        <div className="end-of-recent-notification flex-container">
            <SVGAsset id="InfoIcon" className="set-width inline-text-icon left-icon " />
            <p className="flex-width">
                End of recent transactions. Please use the Search feature to see older transactions.
            </p>
        </div>
    );
}

function TransactionViewTransactions(props) {
    const account = props.account ?? {};
    let rows = props.transactions.map(transaction => {
         return <CustomTransactionAccordion transaction={ transaction } key={ transaction.id } account= { account } /> 
    });

    return (
        <>
            { rows }
        </>
    );
}